import common from './common'

//パラメータ 中型
let applyMediumParam = []
//パラメータ 小型
let smallParam2 = []

let addressFormSelected = ""


function inputRetention(obj) {
    //入力保持
    //指定された年月日
    let sd = new Date(common.getStore(obj, 'specificDate'))
    obj.specificDate = common.getStore(obj, 'specificDate')
    obj.specificDay = '（' + common.constant.DAY_STR_ARRSY[sd.getDay()].name + '）'
    //指定された時間
    obj.specificTime = common.getStore(obj, 'specificTime')
    //郵便番号
    addressFormSelected = common.getStore(obj, 'addressFormSelected')
    obj.postCode = addressFormSelected.YUBIN
    //都道府県・市区町村
    obj.pickupPrefAddress1 = addressFormSelected.TDFKN_KNJI + addressFormSelected.SKGNTYSNNM_KNJI + addressFormSelected.OAZTUSHONM_KNJI
    //町名・番地
    obj.address = common.getStore(obj, 'address')
    //建物名
    obj.buildingName = common.getStore(obj, 'buildingName')
    //携帯電話番号
    obj.pickupTell = common.getStore(obj, 'pickupTell')
    // ご自宅電話番号
    obj.pickupTell2 = common.getStore(obj, 'pickupTell2')
    //メールアドレス
    obj.email = common.getStore(obj, 'email')
    //大型
    obj.largeItems = common.getStore(obj, 'largeItems')
    //中型
    obj.mediumItems = common.getStore(obj, 'mediumItems')
    obj.addMediumItem = common.getStore(obj, 'addMediumItem')
    obj.medium_box_cnt = common.getStore(obj, 'medium_box_cnt')
    //小型
    obj.smallItems = common.getStore(obj, 'smallItems')
    //姓
    obj.sei_kj = common.getStore(obj, 'sei_kj')
    //名
    obj.mei_kj = common.getStore(obj, 'mei_kj')
    //セイ
    obj.sei_kn = common.getStore(obj, 'sei_kn')
    //メイ
    obj.mei_kn = common.getStore(obj, 'mei_kn')
    //生年月日
    let birthday = new Date(common.getStore(obj, 'birthday'))
    obj.birthday = birthday.getFullYear() + '/' + (birthday.getMonth() + 1) + '/' + birthday.getDate()

    //性別
    obj.gender = common.getStore(obj, 'gender')


    // メルマガ受信選択表示が「なし」の場合、メルマガ受信しない
    obj.mail_osr = obj.siteCodeInfo[0].MAIL_OSR_SELECTIVE_DISPLAY_FLG == common.constant.MAIL_OSR_SELECTIVE_DISPLAY
}

async function getFee(obj) {
    let url = common.constant.GET_FEE_URL

    let func = async (response) => {
        
        obj.feeData = Object.assign({}, response.data)
        // 大型
        let large_items = []
        let largeTotalFeeExcLow = 0
        let largeTotalFeeExcHigh = 0
        obj.feeData.large_items.forEach(large_item => {
            //合計金額加算
            largeTotalFeeExcLow += large_item.RECYCLE_FEE_LOW + large_item.TRANSPORTATION_FEE + large_item.REMOVAL_FEE
            largeTotalFeeExcHigh += large_item.RECYCLE_FEE_HIGH + large_item.TRANSPORTATION_FEE + large_item.REMOVAL_FEE
            large_items.push(large_item)
        });
        obj.feeData.large_items = large_items

        // 大型合計金額（税抜）
        obj.largeTotalFeeExc = [largeTotalFeeExcLow + obj.feeData.commission_sgm, largeTotalFeeExcHigh + obj.feeData.commission_sgm]
        // 大型合計金額（税込）
        obj.largeTotalFeeInc = obj.largeTotalFeeExc.map(total => common.includingTax(total, obj.feeData.sales_tax_rate))

        applyMediumParam = []
        //中型
        obj.mediumItems.forEach(medium_item => {
            if (medium_item.unit > 0) {
                calcuOptionTotalFee(obj, medium_item)
            }
        })

        // その他中型
        if (obj.addMediumItem.unit > 0) {
            calcuOptionTotalFee(obj, obj.addMediumItem)
        }
        // 価格設定が「一律」の場合
        if(obj.siteCodeInfo[0].PRICING_METHOD == 1){
            //合計金額加算
            obj.MSTotalFeeExc = obj.MSTotalFeeExc.map(total => total + obj.siteCodeInfo[0].MEDIUM_SMALL_FLAT_PRICE * obj.medium_box_cnt)
        }

        //小型
        let small_items = []
        smallParam2 = []
        obj.feeData.small_items.forEach(small_item => {
            // 価格設定が「一律」の場合、「中型・小型一律価格」で計算
            let fee = obj.siteCodeInfo[0].PRICING_METHOD == 1 ? obj.siteCodeInfo[0].MEDIUM_SMALL_FLAT_PRICE : small_item.FEE
            //合計金額加算
            obj.MSTotalFeeExc = obj.MSTotalFeeExc.map(total => total + fee * obj.smallItems.quantity)
            small_items.push(small_item)
            smallParam2.push({
                'item': small_item.ITEM,
                'item_nm': small_item.ITEM_NM,
                'fee_kbn': small_item.FEE_KBN,
                'fee_kbn_nm': small_item.FEE_KBN_NM,
                'fee_category': small_item.FEE_CATEGORY || '',
                'quantity': obj.smallItems.quantity,
                'smallItemQuantity': obj.smallItems.smallItemQuantity,                
                'fee': fee,
            })
        })
        obj.feeData.small_items = small_items

        // SGW手数料(中型、小型の手数料)
        if(obj.MSTotalFeeExc[0] == 0) obj.feeData.commission_sgw = 0
        //手数料税込み
        obj.feeData.commission = obj.feeData.commission_sgm + obj.feeData.commission_sgw
        //合計金額算出
        // 中型・小型合計料金(税抜)(手数料抜)
        obj.total_m_s_exc = obj.MSTotalFeeExc[0]
        // 中型・小型合計料金(税込)(手数料抜)
        obj.total_m_s_inc = common.includingTax(obj.MSTotalFeeExc[0], obj.feeData.sales_tax_rate)
        // 合計料金(税抜)
        obj.MSTotalFeeExc = obj.MSTotalFeeExc.map(total => total + obj.feeData.commission_sgw)
        // 合計料金(税込)
        obj.MSTotalFeeInc = obj.MSTotalFeeExc.map(total => common.includingTax(total, obj.feeData.sales_tax_rate))

        if(obj.siteCodeInfo[0].REQUIRE_CONTRACT_FLG == "1") await getContract(obj)
    }

    //API呼び出しのための型変換
    //大型
    let largeParam = []
    obj.largeItems.forEach(largeItem => {
        largeItem.selectedMakerSizeList.forEach(selectedMakerSize => {
            let temp = {
                'item': largeItem.code,
                'maker': selectedMakerSize.selectedMaker.CODE,
                'item_size': selectedMakerSize.selectedSize ? selectedMakerSize.selectedSize.CODE : '',
            }
             // 取り外し作業
            if (largeItem.code === common.constant.CODE_AC) {
                temp['removalWork'] = selectedMakerSize.selectedRemovalWork
            }
            largeParam.push(temp)
            obj.largeQuantity += 1
        });
    });
    //中型
    let mediumParam = []
    obj.mediumItems.forEach(mediumItem => {
        if (mediumItem.unit) {
            mediumParam.push({
                'item': mediumItem.code,
                'quantity': mediumItem.unit,
            })
        }
    });
    // その他中型
    if (obj.addMediumItem.unit) {
        mediumParam.push({
            'item': obj.addMediumItem.code,
            'quantity': obj.addMediumItem.unit
        })
    }
    // 中型の箱数を設定
    obj.mediumSmallQuantity = obj.medium_box_cnt
    //小型
    let smallParam = []
    if (obj.smallItems.quantity > 0) {
        smallParam.push({
            'item': obj.smallItems.code,
            'quantity': obj.smallItems.quantity,
        })
        obj.mediumSmallQuantity += obj.smallItems.quantity
    }

    let params = {
        yubin: obj.postCode.replace('-', ''),
        large_items: largeParam,
        medium_items: mediumParam,
        small_items: smallParam,
        site_code: process.env.VUE_APP_SITE_CODE,
    }
    //API呼出
    await common.executeAxiosPost(url, func, params, obj)
}

// 各品目のオプション料金と合計金額の計算
function calcuOptionTotalFee(obj, data) {
    // 価格設定が「一律」の場合、「中型・小型一律価格」で計算
    let fee = obj.siteCodeInfo[0].PRICING_METHOD == 1 ? obj.siteCodeInfo[0].MEDIUM_SMALL_FLAT_PRICE : data.fee
    
    data.options.forEach(option => option['fee'] = 0) // オプション料金の保持用
    let total_option_fee_exc_tax = 0

    // 申込登録用パラメータ-中型-詳細データ
    let details = [];
    details.push({
      'fee_kbn': "1",
      'fee_kbn_nm': getMainFeeKbnName(obj.feeData.medium_items, data.code),
      'fee_category': null,
      'fee': fee,
    })

    // 価格設定が「個別」の場合のみオプション料金を計算
    if (obj.siteCodeInfo[0].PRICING_METHOD == 2) {
        for (let kbn in data.selectedOptions) {
            let option_data = data.options.find(item => item.fee_kbn.code == kbn)
            let fee_cat_data = option_data.fee_cat.find(item => item.code == data.selectedOptions[kbn].feeCat)
            option_data['fee'] = fee_cat_data.fee
            total_option_fee_exc_tax += fee_cat_data.fee * data.unit

            // 申込登録用パラメータ-中型-詳細データに追加
            details.push({
              'fee_kbn': option_data.fee_kbn.code,
              'fee_kbn_nm': option_data.fee_kbn.name,
              'fee_category': fee_cat_data.code,
              'fee_cat_nm': fee_cat_data.name,
              'fee': fee_cat_data.fee,
            })
        }
        // 回収料金区分の料金を計算
        let small_kbn_fee_exc = data.fee * data.unit

        // 合計金額加算
        obj.MSTotalFeeExc = obj.MSTotalFeeExc.map(totalExc => totalExc + small_kbn_fee_exc + total_option_fee_exc_tax)
    }
    // 申込登録用パラメータ-中型に追加
    applyMediumParam.push({
      'item': data.code,
      'item_nm': data.name,
      'quantity': data.unit,
      'details': details
    })
}

function submitConfirmDisp(obj, path) {
    obj.setErrorFlg(false)

    // アンケートデータ整理
    let enqueteData = []
    let selected = common.getStore(obj, 'enquete').selected
    let freeInput = common.getStore(obj, 'enquete').freeInput
    obj.enqueteMaster.forEach(item => {
        let data = {
            question: item.question.QUESTION_CONTENT,
            answer: []
        }
        // チェックボックスの場合
        if (item.question.QUESTION_METHOD === 1) {
            selected['question_' + item.question.ENQUETE_QUESTION_ID].forEach(answerId => {
                let matchItem = item.answers.find(ans => ans.ENQUETE_ANSWER_ID === answerId)
                if (matchItem) {
                    data.answer.push(matchItem.ANSWER_CONTENT)
                    if (matchItem.FREE_INPUT_FLG) {
                        data.answer.push(freeInput['answer_' + matchItem['ENQUETE_ANSWER_ID']])
                    }
                }
            })
        } else if (item.question.QUESTION_METHOD === 2) {
            let matchItem = item.answers.find(ans => ans.ENQUETE_ANSWER_ID === selected['question_' + item.question.ENQUETE_QUESTION_ID])
            if (matchItem) {
                data.answer.push(matchItem.ANSWER_CONTENT)
                if (matchItem.FREE_INPUT_FLG) {
                    data.answer.push(freeInput['answer_' + matchItem['ENQUETE_ANSWER_ID']])
                }
            }
        } else if (item.question.QUESTION_METHOD === 3) {
            data.answer.push(freeInput['answer_' + item.answers[0].ENQUETE_ANSWER_ID])
        }
        enqueteData.push(data)
    })

    //API呼び出しのための型変換
    //大型
    let largeParam2 = []
    obj.feeData.large_items.forEach(largeItem2 => {
        largeParam2.push({
            'item': largeItem2.ITEM,
            'item_nm': largeItem2.ITEM_NM,
            'item_cd_nm': largeItem2.ITEM_CD_NM,
            'item_cd': largeItem2.ITEM_CD,
            'maker': largeItem2.MAKER,
            'item_size': largeItem2.ITEM_SIZE || '',
            'maker_nm': largeItem2.MAKER_NM,
            'item_size_nm': largeItem2.ITEM_SIZE_NM,
            'recycle_fee_low': largeItem2.RECYCLE_FEE_LOW,
            'recycle_fee_high': largeItem2.RECYCLE_FEE_HIGH,
            'quantity': 1,
            'transportation_fee': largeItem2.TRANSPORTATION_FEE,
            'removal_fee': largeItem2.REMOVAL_FEE,
        })
    });

    //サンクス画面用データ
    obj.itemsDataTax = {
        large_items: largeParam2,
        medium_items: applyMediumParam,
        small_items: smallParam2,
        largeTotalFeeLowInc: obj.largeTotalFeeInc[0],//大型最低合計金額（税込）(手数料込)
        mediumSmallTotalFee: obj.MSTotalFeeInc[0],//中型小型合計金額（税込）(手数料込)
        mediumSmallQuantity: obj.mediumSmallQuantity//中型小型合計箱数
    }

    let url = common.constant.CONF_APP_URL

    let func = (response) => {
        obj.itemsDataTax['apply_id'] = response.data.apply_id

        common.setStore(obj, 'itemsDataTax', obj.itemsDataTax)
        common.setStore(obj, 'erasePcNum', response.data.erasePcNum)
        common.setRoute(obj, path)

    }
    
    let contractorSei_kj = ""
    let contractorMei_kj = ""
    let contractorSei_kn = ""
    let contractorMei_kn = ""
    let companyName = common.getStore(obj, 'companyName')
    let department = common.getStore(obj, 'department')
    let contractCompanyName = ""
    let contractDepartment = ""
    let contractCompanyZipcode = ""
    let contractCompanyAddress = ""
    let contractCompanyTell = ""
    let selectEmployee = common.getStore(obj, 'selectEmployee')
    let selectIndustry = common.getStore(obj, 'selectIndustry')

    let checkContractor = common.getStore(obj, 'checkContractor')

    // お申込み者がご契約者名と異なる場合
    if(checkContractor) {
        contractorSei_kj = common.getStore(obj, 'contractorSei_kj')
        contractorMei_kj = common.getStore(obj, 'contractorMei_kj')
        contractorSei_kn = common.getStore(obj, 'contractorSei_kn')
        contractorMei_kn = common.getStore(obj, 'contractorMei_kn')
        contractCompanyName = common.getStore(obj, 'contractCompanyName')
        contractDepartment = common.getStore(obj, 'contractDepartment')
        contractCompanyZipcode = common.getStore(obj, 'contractCompanyZipcode')
        contractCompanyAddress = common.getStore(obj, 'contractCompanyAddress')
        contractCompanyTell = common.getStore(obj, 'contractCompanyTell')
    }

    let postCodeArr = obj.postCode.split( '-' )
    let params = {
        pickup_jis5cd: addressFormSelected.JIS5CD,
        pickup_zipcode: obj.postCode.replace('-', ''),
        pickup_zipcode_before: postCodeArr[0],
        pickup_zipcode_after: postCodeArr[1],
        pickup_pref: addressFormSelected.TDFKN_KNJI,
        pickup_address1: addressFormSelected.SKGNTYSNNM_KNJI + addressFormSelected.OAZTUSHONM_KNJI,
        address: obj.address,
        building_name: obj.buildingName,
        pickup_date: common.getStore(obj, 'specificDate'),
        pickup_time_id: obj.specificTime.CODE,
        pickup_time: obj.specificTime.CODE_NM,
        sei_kj: obj.sei_kj,
        mei_kj: obj.mei_kj,
        sei_kn: obj.sei_kn,
        mei_kn: obj.mei_kn,
        pickup_tel: obj.pickupTell,
        email: obj.email,
        birthday: obj.birthday,
        gender: obj.gender,
        mail_osr: obj.mail_osr ? '1' : '0',
        sales_tax_rate: obj.feeData.sales_tax_rate,
        large_items: largeParam2,
        medium_items: applyMediumParam,
        medium_box_cnt: obj.medium_box_cnt,
        small_items: smallParam2,
        commission_sgm: obj.feeData.commission_sgm,
        commission_sgw: obj.feeData.commission_sgw,
        site_code: process.env.VUE_APP_SITE_CODE,
        total_m_s: obj.total_m_s_inc,
        enquete: enqueteData,
        enqueteSelected: selected,
        freeInput: freeInput,
        dataEraseService: common.constant.DATA_ERASE_SERVICE,
        contractorSei_kj: contractorSei_kj,
        contractorMei_kj: contractorMei_kj,
        contractorSei_kn: contractorSei_kn,
        contractorMei_kn: contractorMei_kn,
        companyName: companyName,
        department: department,
        contractCompanyName: contractCompanyName,
        contractDepartment: contractDepartment,
        contractCompanyZipcode: contractCompanyZipcode,
        contractCompanyAddress: contractCompanyAddress,
        contractCompanyTell: contractCompanyTell,
        selectEmployee: selectEmployee,
        selectIndustry: selectIndustry,
        check_contractor: checkContractor,
        contract_url: obj.siteCodeInfo[0].REQUIRE_CONTRACT_FLG == "1" ? process.env.VUE_APP_BASE_URL + common.constant.BASE_PATH + common.constant.REPORT_DOWNLOAD_PAGE_PATH : "",
        referralCompanyCode: common.getStore(obj, 'referralCompanyCode')
    }
    // console.log(params.enquete, params.enqueteSelected, params.freeInput)
    // console.log(url, func, params)
    // API呼び出し
    common.executeAxiosPost(url, func, params, obj)
}

// 選択した料金区分を取得
function getSelectedFeeCatName(item, option) {
  return option.fee_cat.find(cat => cat.code == item.selectedOptions[option.fee_kbn.code].feeCat).name
}

// 本体の料金区分名を取得
function getMainFeeKbnName(item, code) {
  return item ? item.find(x => x.ITEM == code).FEE_KBN_NM : ""
}

// 契約書内容取得
async function getContract(obj) {
    let url = common.constant.CREATE_CONTRACT_URL
    let checkContractor = common.getStore(obj, 'checkContractor')
    let func = (response) => {
        let contractArea = document.getElementById('contract_area');
        contractArea.innerHTML = response.data
    }
    let params = {
        font_style: "",
        contract_company_name: checkContractor? common.getStore(obj, 'contractCompanyName'):common.getStore(obj, 'companyName'),
        pickup_pref: addressFormSelected.TDFKN_KNJI,
        pickup_address1: addressFormSelected.SKGNTYSNNM_KNJI + addressFormSelected.OAZTUSHONM_KNJI,
        address: obj.address,
        building_name: obj.buildingName,
        medium_items: applyMediumParam,
        small_items: smallParam2,
        commission_sgw: obj.feeData.commission_sgw,
        site_code: process.env.VUE_APP_SITE_CODE,
        sales_tax_rate: obj.feeData.sales_tax_rate,
        pricing_method: obj.siteCodeInfo[0].PRICING_METHOD,
        medium_small_flat_price: obj.siteCodeInfo[0].MEDIUM_SMALL_FLAT_PRICE
    }

    //API呼出
    await common.executeAxiosPost(url, func, params, obj)
}

// 契約書ダウンロード
function contractDownload(obj) {
    let checkContractor = common.getStore(obj, 'checkContractor')
    let params = {
        font_style: common.constant.FONT_STYLE,
        contract_company_name: checkContractor? common.getStore(obj, 'contractCompanyName'):common.getStore(obj, 'companyName'),
        pickup_pref: addressFormSelected.TDFKN_KNJI,
        pickup_address1: addressFormSelected.SKGNTYSNNM_KNJI + addressFormSelected.OAZTUSHONM_KNJI,
        address: obj.address,
        building_name: obj.buildingName,
        medium_items: applyMediumParam,
        small_items: smallParam2,
        commission_sgw: obj.feeData.commission_sgw,
        site_code: process.env.VUE_APP_SITE_CODE,
        sales_tax_rate: obj.feeData.sales_tax_rate,
        pricing_method: obj.siteCodeInfo[0].PRICING_METHOD,
        medium_small_flat_price: obj.siteCodeInfo[0].MEDIUM_SMALL_FLAT_PRICE
    }

    let url = common.constant.DOWNLOAD_CONTRACT_URL

    common.contractDownload(obj, url, params, false)

}

export default {
    common,
    inputRetention,
    getFee,
    submitConfirmDisp,
    calcuOptionTotalFee,
    getSelectedFeeCatName,
    getMainFeeKbnName,
    getContract,
    contractDownload
}
